import classes from "./NavBar.module.css"
import React, { useState } from "react";
import CustomizedSlider from "../CustomizedSlider/CustomizedSlider";
import SearchBar from "./SearchBar";
import { Link } from 'react-router-dom'
const NavBar = ({ title, month, setMonth, location }) => {
    const [isNavExpanded, setIsNavExpanded] = useState(false)
    return (
        <nav className={month === 0 ? classes.navigation_short : classes.navigation}>
            {/* <div>{isNavExpanded ? 'show' : 'hide'}</div> */}
            <img className={classes.image} alt="field-guide-icon" src="/img/numbat_medium_orange.png"></img>
            {/* <a href={"/"+location.slug} className={classes.brandName}>{title}</a> */}
            
            <div className={isNavExpanded ? classes.navigationMenu_expanded : classes.navigationMenu}>
                <ul className={classes.navigationMenu__list}>
                    <li className={classes.navigationMenu__listItem}><Link to={'/'+location.slug}>Home</Link></li>
                    <li className={classes.navigationMenu__listItem}><Link to={location.slug+'/about'}>About</Link></li>
                    <li className={classes.navigationMenu__listItem}><Link to={location.slug+'/contact'}>Contact</Link></li>
                </ul>
            </div>
            <div className={classes.searchBar}>
                <SearchBar />
            </div>
            <button className={classes.hamburger} onClick={() => {
                setIsNavExpanded(!isNavExpanded);
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>
            {month !== 0 && <CustomizedSlider setMonth={setMonth} />}
        </nav>
    )
}

export default NavBar
